import { Controller } from "@hotwired/stimulus"

class EmbeddedCheckoutController extends Controller {
  static values = {
    publicKey: String,
    clientSecret: String,
  }

  async connect() {
    // Wait for Stripe to be available
    await this.waitForStripe()
    
    this.stripe = Stripe(this.publicKeyValue)
    this.checkout = await this.stripe.initEmbeddedCheckout({clientSecret: this.clientSecretValue})
    this.checkout.mount(this.element)
  }

  async waitForStripe() {
    return new Promise((resolve) => {
      if (window.Stripe) {
        resolve()
      } else {
        const checkStripe = () => {
          if (window.Stripe) {
            resolve()
          } else {
            setTimeout(checkStripe, 100)
          }
        }
        checkStripe()
      }
    })
  }

  disconnect() {
    if (this.checkout) {
      this.checkout.destroy()
    }
  }
}

export default EmbeddedCheckoutController
